import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSystemInitialization } from '../../../hooks/useSystemInitialization.js';
import { selectIsAdmin } from '../../../store/user/user.selector.js';

// assets
import logo from '../../../assets/system/pull-vault-logo-light.png';

// components
import HeaderCardCountPill from './components/header-card-count-pill/HeaderCardCountPill';
import HeaderFriendsPill from './components/header-friends-pill/HeaderFriendsPill';
import HeaderProfilePill from './components/header-profile-pill/HeaderProfilePill';
import HeaderPSAPill from './components/header-psa-pill/HeaderPSAPill';
import HeaderTokenPill from './components/header-token-pill/HeaderTokenPill';
import HeaderWhatnotPill from './components/header-whatnot-pill/HeaderWhatnotPill';
import HeaderGroupCodeField from './components/header-group-code-field/HeaderGroupCodeField';

// styles
import {
  HeaderContainer,
  LeftContent,
  RightContent
} from './Header.styles.js';

export default function Header({ rightContent = true }) {
  const navigate = useNavigate();
  const isAdmin = useSelector(selectIsAdmin);
  const logoMemo = useMemo(() => logo, []);
  const { 
    checklistSportDefault, 
    checklistYearDefault, 
    checklistManufacturerDefault 
  } = useSystemInitialization();

  const handleNavigate = useCallback((path) => {
    navigate(path);
  }, [navigate]);

  return (
    <HeaderContainer $rightContent={rightContent}>
      <LeftContent>
        <img src={logoMemo} alt='Pull Vault logo' onClick={() => handleNavigate('/')} />
      </LeftContent>
      {rightContent &&
        <RightContent>
          <HeaderGroupCodeField />
          {isAdmin && <HeaderWhatnotPill navigateTo='/whatnot' />}
          {isAdmin && <HeaderPSAPill navigateTo='/psa' />}
          {isAdmin && <HeaderFriendsPill navigateTo='/friends' />}
          <HeaderTokenPill navigateTo='/tokens' />
          <HeaderCardCountPill navigateTo={`/checklists/${checklistSportDefault}/${checklistYearDefault}/${checklistManufacturerDefault}`} />
          <HeaderProfilePill />
        </RightContent>
      }
    </HeaderContainer>
  );
}